import React from 'react'

import styles from './styles.module.css'

export interface EmptyCardTextProps {
  content: React.ReactNode
  'data-ocweb-id': string
}

export const EmptyCardText: React.FC<EmptyCardTextProps> = ({
  content,
  'data-ocweb-id': dataTestId
}) => {
  return (
    <div className={styles.emptyCardText} data-ocweb-id={dataTestId}>
      {content}
    </div>
  )
}

export default EmptyCardText
